import classNames from "classnames";
import { FC } from "react";

import styles from "./ShortlinkPanel.module.scss";
import { Icon, IconButton } from "@livingmap/hippo";
import { CopyToClipboard } from "react-copy-to-clipboard";

interface Props {
  dataQA: string;
  className?: string;
  qrCode: {
    svg_base64: string;
    png_base64: string;
  };
  shortlinkUrl: string | null;
  name: string;
  createdAt: string;
  modifiedAt?: string;
  onEdit: () => void;
}

const ShortlinkPanel: FC<Props> = ({
  dataQA,
  className,
  qrCode,
  createdAt,
  name,
  onEdit,
  shortlinkUrl,
  modifiedAt,
}) => {
  const formatter = new Intl.DateTimeFormat("en-US", {
    month: "short", // abbreviated month name
    day: "numeric", // numeric day
    year: "numeric", // numeric year
  });

  return (
    <div data-qa={dataQA} className={classNames(styles.container, className)}>
      <div className={styles.qrCode}>
        <img
          src={`data:image/svg+xml;base64,${qrCode.svg_base64}`}
          alt="QR Code"
          className={styles.qrCodeImage}
        />
      </div>
      <div className={styles.details}>
        <span className={styles.title}>{name}</span>
        {shortlinkUrl && (
          <div className={styles.link}>
            <Icon
              className={styles.icon}
              dataQA="link-icon"
              name="link"
              size={18}
            />
            <span>{shortlinkUrl}</span>
            <CopyToClipboard text={shortlinkUrl}>
              <Icon
                className={styles.icon}
                dataQA="copy-link-icon"
                name="content_copy"
                size={18}
              />
            </CopyToClipboard>
          </div>
        )}
        <div className={styles.history}>
          <div>
            <Icon
              className={styles.icon}
              dataQA="created-at-icon"
              name="timer"
              size={18}
            />
            <span>{formatter.format(new Date(createdAt))}</span>
          </div>
          {modifiedAt && (
            <div>
              <Icon
                className={styles.icon}
                dataQA="created-at-icon"
                name="edit"
                size={18}
              />
              <span>{formatter.format(new Date(modifiedAt))}</span>
            </div>
          )}
        </div>
      </div>
      <div className={styles.controls}>
        <IconButton
          dataQA="edit-shortlink-button"
          icon="edit"
          size="regular"
          iconSize={24}
          type="primary"
          onClick={onEdit}
          className={styles.editButton}
        />
      </div>
    </div>
  );
};

export default ShortlinkPanel;
